// src/i18n/locales/ar/settings.ts (Updated)
export const arSettingsTranslations = {
	settings: {
		onePageLayout: 'تخطيط صفحة واحدة',
		onePageLayoutOptions: {
			yes: 'نعم',
			no: 'لا',
		},
		allowedLanguages: 'اللغات المسموح بها',
		allowedLanguagesHelper: 'يجب اختيار لغة واحدة على الأقل. الإنجليزية هي اللغة الافتراضية.',
		languageOptions: {
			en: 'الإنجليزية',
			ar: 'العربية',
		},
		isFeedbackEnabled: 'تفعيل تقييم وملاحظات العناصر',
		isFeedbackEnabledOptions: {
			yes: 'نعم',
			no: 'لا',
		},
		isFeedbackPubliclyVisible: 'إظهار التقييم على العناصر',
		isFeedbackPubliclyVisibleOptions: {
			yes: 'مرئي',
			no: 'مخفي',
		},
		// Page titles and general labels
		title: 'إعدادات المطعم',
		subtitle: 'خصص مظهر ومعلومات مطعمك',
		saveChanges: 'حفظ التغييرات',
		saving: 'جارٍ الحفظ...',
		saveSuccess: 'تم حفظ الإعدادات بنجاح!',
		resetToDefaults: 'إعادة إلى الإعدادات الافتراضية',
		hidePreview: 'إخفاء المعاينة',
		showPreview: 'إظهار المعاينة',
		menuPreview: 'معاينة القائمة',
		previewDescription: 'هكذا ستظهر قائمتك للعملاء',
		livePreview: 'معاينة مباشرة',
		unsavedChanges: 'تغييرات غير محفوظة',

		// Tabs
		tabs: {
			theme: 'المظهر',
			layout: 'التخطيط',
			typography: 'الخطوط',
			brand: 'العلامة التجارية',
			contact: 'التواصل',
			hours: 'ساعات العمل',
			currency: 'العملة',
			services: 'الخدمات',
			features: 'المميزات',
			ingredients: 'المكونات',
		},

		// Theme settings
		colorPalettes: 'لوحات الألوان',
		customColors: 'ألوان مخصصة',
		primaryColor: 'اللون الأساسي',
		secondaryColor: 'اللون الثانوي',
		accentColor: 'لون التمييز',
		backgroundColor: 'لون الخلفية',
		cardBackgroundColor: 'خلفية البطاقة',
		textColor: 'لون النص',
		borderColor: 'لون الحدود',
		cardColor: 'لون البطاقة',

		// Custom Themes
		customThemes: 'المظاهر المخصصة',
		defaultTheme: 'المظهر الافتراضي',
		addTheme: 'إضافة مظهر',
		editTheme: 'تعديل المظهر',
		deleteTheme: 'حذف المظهر',
		saveTheme: 'حفظ المظهر',
		themeName: 'اسم المظهر',
		themeNamePlaceholder: 'أدخل اسم المظهر',
		themePreview: 'معاينة المظهر',
		themeDeleteConfirm: 'هل تريد حذف هذا المظهر؟',
		noCustomThemes: 'أنشئ أول مظهر مخصص لك',
		addToCartOptions: {
			yes: 'نعم',
			no: 'لا',
		},

		// Style options
		styleOptions: 'خيارات النمط',
		headerStyle: 'نمط الرأس',
		headerStyles: {
			transparent: 'شفاف',
			solid: 'صلب',
			cover: 'غلاف'
		},
		cardStyle: 'نمط البطاقة',
		cardStyles: {
			minimal: 'بسيط',
			shadow: 'ظل',
			bordered: 'محدود'
		},

		// Layout settings
		menuLayout: 'تخطيط القائمة',
		menuStyle: 'نمط القائمة',
		menuStyles: {
			grid: 'شبكة',
			list: 'قائمة'
		},
		SubcategoryStyle: 'نمط الفئة الفرعية',
		SubcategoryStyles: {
			tabs: 'تبويبات',
			dropdown: 'قائمة منسدلة'
		},
		menuSortType: 'ترتيب القائمة',
		menuSortTypes: {
			manual: 'يدوي (سحب وإفلات)',
			alphabetic: 'أبجدي',
			time: 'حسب تاريخ الإضافة',
		},
		dragToReorder: 'اسحب لإعادة الترتيب',
		searchActiveNoDnd: 'امسح البحث لتفعيل الترتيب اليدوي',
		savingOrder: 'جارٍ حفظ الترتيب...',
		borderRadius: 'نصف قطر الحدود',

		// Typography settings
		fontFamily: 'نوع الخط',
		titleFontFamily: 'نوع الخط المزخرف',
		titleFontSize: 'حجم العنوان',
		itemFontSize: 'حجم اسم العنصر',
		boldTitles: 'عناوين بخط عريض',

		// Brand settings
		restaurantInfo: 'معلومات المطعم',
		restaurantName: 'اسم المطعم (بالإنجليزية)',
		restaurantNamePlaceholder: 'أدخل اسم مطعمك بالإنجليزية',
		restaurantNameArabic: 'اسم المطعم (بالعربية)',
		restaurantNameArabicPlaceholder: 'أدخل اسم مطعمك بالعربية',
		description: 'الوصف (بالإنجليزية)',
		descriptionPlaceholder: 'صف مطعمك ونوع الطعام بالإنجليزية',
		descriptionArabic: 'الوصف (بالعربية)',
		descriptionArabicPlaceholder: 'صف مطعمك ونوع الطعام بالعربية',
		cuisine: 'نوع المطبخ',
		cuisinePlaceholder: 'مثل: إيطالي، صيني، أمريكي',
		brandImages: 'صور العلامة التجارية',
		logo: 'الشعار',
		uploadLogo: 'انقر لرفع الشعار أو اسحب وأفلت',
		coverImage: 'صورة الغلاف',
		uploadCoverImage: 'انقر لرفع صورة الغلاف أو اسحب وأفلت',
		logoUploaded: 'تم رفع الشعار بنجاح',
		coverImageUploaded: 'تم رفع صورة الغلاف بنجاح',
		defaultItemImage: 'صورة العنصر الافتراضية',
		defaultItemImageUploaded: 'تم رفع صورة العنصر الافتراضية بنجاح',
		uploadDefaultItemImage: 'انقر لرفع صورة العنصر الافتراضية أو اسحب وأفلت',
		clickToChange: 'انقر لتغيير الصورة',
		supportedFormats: 'PNG، JPG، WebP حتى 5 ميجابايت',
		uploading: 'جارٍ الرفع...',

		// Location settings
		location: 'الموقع',
		googleMapsLink: 'رابط خرائط جوجل',
		googleMapsLinkPlaceholder: 'https://maps.google.com/...',
		coordinatesPlaceholder: '40.71817374700872, -74.01229668987044',
		or: 'أو',
		coordinates: 'الإحداثيات',
		latitude: 'خط العرض',
		longitude: 'خط الطول',
		coordinatesHelper: 'يمكنك الحصول على الإحداثيات بالنقر بالزر الأيمن على خرائط جوجل',
		currentLocation: 'الموقع الحالي',
		selectOnMap: 'اختر على الخريطة',
		mapPicker: 'منتقي الموقع على الخريطة',
		dragMarker: 'اسحب العلامة لتحديد موقعك',
		confirmLocation: 'تأكيد الموقع',
		cancel: 'إلغاء',
		searchLocation: 'ابحث عن موقع...',
		useCurrentLocation: 'استخدم الموقع الحالي',
		locationSelected: 'تم تحديد الموقع',

		// Contact settings
		contactInfo: 'معلومات التواصل',
		phone: 'رقم الهاتف',
		phonePlaceholder: '+966 5XXXXXXXX',
		email: 'البريد الإلكتروني',
		emailPlaceholder: 'restaurant@example.com',
		address: 'العنوان (بالإنجليزية)',
		addressPlaceholder: 'أدخل عنوان مطعمك بالإنجليزية',
		addressArabic: 'العنوان (بالعربية)',
		addressArabicPlaceholder: 'أدخل عنوان مطعمك بالعربية',
		addAddress: 'إضافة عنوان',
		removeAddress: 'إزالة العنوان',
		socialMedia: 'وسائل التواصل الاجتماعي',
		facebook: 'فيسبوك',
		instagram: 'إنستغرام',
		twitter: 'تويتر',

		// Services settings
		services: {
			title: 'الخدمات',
			subtitle: 'تمكين وتكوين الخدمات المتقدمة لمطعمك',
			addFeature: 'إضافة خدمة',
			noFeatures: 'لا توجد خدمات مضافة',
			noFeaturesDescription: 'أضف خدمات لتعزيز قدرات مطعمك',
			allFeaturesAdded: 'تم إضافة جميع الخدمات المتاحة إلى مطعمك',
			enabled: 'مفعّل',
			deleteFeature: 'حذف الخدمة',
			deleteFeatureConfirmation: 'هل أنت متأكد من حذف هذه الخدمة؟ لا يمكن التراجع عن هذا الإجراء.',
			manageRestaurantFeatures: 'إدارة وتكوين خدمات المطعم',
			addNewFeature: 'إضافة خدمة جديدة',
			createCustomFeature: 'إنشاء خدمة مخصصة لمطعمك',
			addFirstFeature: 'أضف خدمتك الأولى للبدء',
			noFeaturesYet: 'لم يتم تكوين أي خدمات بعد',
			noFeaturesFound: 'لم يتم العثور على خدمات',
			tryDifferentSearch: 'جرب تعديل معايير البحث أو التصفية',
			searchFeatures: 'البحث في الخدمات...',
			featureName: 'اسم الخدمة',
			enterFeatureName: 'أدخل اسم الخدمة...',
			featureDescription: 'الوصف',
			enterFeatureDescription: 'أدخل وصف الخدمة...',
			enterDescription: 'أدخل الوصف...',
			category: 'الفئة',
			enterCategory: 'أدخل الفئة...',
			icon: 'الأيقونة',
			iconUrl: 'رابط الأيقونة',
			enterIconUrl: 'أدخل رابط أيقونة الخدمة (مثال: https://example.com/icon.png)',
			iconPreview: 'معاينة الأيقونة',
			enterIconEmoji: 'أدخل رمز الأيقونة (مثل 🍕)',
			iconHelp: 'استخدم رمز تعبيري لتمثيل هذه الخدمة',
			featureImage: 'صورة الخدمة',
			clickToUpload: 'انقر للرفع',
			orDragAndDrop: 'أو اسحب وأفلت',
			allowItems: 'السماح بالعناصر',
			allowItemsHelp: 'فعّل هذا الخيار إذا كان يمكن ربط هذه الخدمة بعناصر القائمة',
			selectFeatureToAdd: 'اختر خدمة لإضافتها',
			filterByCategory: 'تصفية حسب الفئة',
			allCategories: 'جميع الفئات',
			selectCategory: 'اختر الفئة',
			configuration: 'التكوين',
			featureConfiguration: 'تكوين الخدمة',
			configurationText: 'نص التكوين',
			currentConfiguration: 'التكوين الحالي',
			attachedItems: 'العناصر المرفقة',
			configureFeature: 'تكوين الخدمة',
			clickAddFeatureToStart: 'انقر على "إضافة خدمة" للبدء',
			enterConfiguration: 'أدخل التكوين...',
			enterConfigText: 'أدخل نص التكوين...',
			noConfiguration: 'لا يوجد تكوين',
			editConfiguration: 'تحرير التكوين',
			createFeature: 'إنشاء خدمة',
			creating: 'جارٍ الإنشاء...',
			removeFeature: 'إزالة الخدمة',
			removeFeatureConfirmation: 'هل أنت متأكد من إزالة هذه الخدمة من فرعك؟ لا يمكن التراجع عن هذا الإجراء.',
			enterJsonConfiguration: 'أدخل إعدادات JSON...',
			jsonConfigurationHelp: 'أدخل إعدادات JSON صحيحة لهذه الخدمة',
			itemsAttached: 'عنصر مرفق',
			manageItems: 'إدارة العناصر',
			invalidJsonFormat: 'تنسيق JSON غير صحيح',
			featureInformation: 'معلومات الخدمة',
			subfeatures: 'الخدمات الفرعية',
			subfeature: 'خدمة فرعية',
			subfeatureOptional: 'الخدمات الفرعية (اختياري)',
			addSubfeature: 'إضافة خدمة فرعية',
			subfeatureName: 'اسم الخدمة الفرعية',
			subfeatureImage: 'صورة الخدمة الفرعية',
			noSubfeaturesAdded: 'لم تتم إضافة خدمات فرعية. انقر على "إضافة خدمة فرعية" لإنشاء واحدة.',
			textClass: 'النص/الصنف',
			uploadImage: 'رفع صورة',
			chooseImage: 'اختر صورة',
			uploading: 'جارٍ الرفع...',
			editFeature: 'تعديل الخدمة',
			updateFeature: 'تحديث الخدمة',
			cancel: 'إلغاء',
			hideSettings: 'إخفاء الإعدادات',
			showSettings: 'إظهار الإعدادات',
			errorSavingConfiguration: 'خطأ في حفظ التكوين',
			featureIcon: 'أيقونة الخدمة',
			noIcon: 'لا توجد أيقونة',
			chooseIcon: 'اختر أيقونة',
			removeIcon: 'إزالة',
			updating: 'جارٍ التحديث...',
			nameRequired: 'اسم الخدمة مطلوب',
			invalidFileType: 'نوع ملف غير صحيح. يُسمح فقط بـ JPEG و PNG و WebP.',
			fileTooLarge: 'الملف كبير جداً. الحد الأقصى 5 ميجابايت.',
			errorUploadingImage: 'فشل في رفع الصورة. يرجى المحاولة مرة أخرى.',
		},

		fontSizes: 'أحجام الخطوط',

		// Operating hours
		operatingHours: 'ساعات العمل',
		customerArrivalTime: 'وقت وصول العميل',
		customerArrivalTimeDescription: 'حدد المدة التي يجب على العملاء الانتظار قبل وقت الحجز الخاص بهم',
		selectArrivalTime: 'اختر مدة الوصول',
		timeOptions: 'خيارات الوقت',
		addTimeOption: 'إضافة خيار وقت',
		addFirstTimeOption: 'إضافة خيار وقت',
		default: 'الافتراضي',
		arrivalTimes: {
			fifteenMin: '15 دقيقة',
			thirtyMin: '30 دقيقة',
			fortyFiveMin: '45 دقيقة',
			oneHour: 'ساعة واحدة',
			twoHours: 'ساعتان',
		},
		days: {
			monday: 'الاثنين',
			tuesday: 'الثلاثاء',
			wednesday: 'الأربعاء',
			thursday: 'الخميس',
			friday: 'الجمعة',
			saturday: 'السبت',
			sunday: 'الأحد'
		},
		closed: 'مغلق',

		// Preview content
		preview: {
			addToCart: 'إضافة'
		},

		// Error messages
		errors: {
			saveFailed: 'فشل في حفظ الإعدادات. يرجى المحاولة مرة أخرى.',
			invalidColor: 'يرجى إدخال قيمة لون صالحة',
			requiredField: 'هذا الحقل مطلوب',
			invalidUrl: 'يرجى إدخال رابط صالح'
		}
	}
};